/** @jsx jsx */
import { DottedList, DottedListItem, Flex, Paragraph } from "@eworkit/iris";
import { FC, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { LazyUserAvatar } from "@/components/avatars";
import { ResponsiveCard } from "@/components/ResponsiveCard";
import { UserContext } from "@/components/User";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";

interface ApplyManagersListCardProps {
  profile: IConsultantProfile;
  onChange: (value: IConsultantProfile) => void;
}

export const ApplyManagersListCard: FC<ApplyManagersListCardProps> = ({ profile, onChange }) => {
  const { t } = useTranslation("session");

  const { contextConsultantProfileId } = useContext(UserContext);

  const handleClick = useCallback(() => {
    onChange(profile);
  }, [profile, onChange]);

  return (
    <ResponsiveCard
      as="button"
      breakpoint="md"
      onClick={handleClick}
      sx={{
        px: ["sm", "sm", "md", "md"],
        py: ["sm", "sm", "sm", "sm"],
        borderTopWidth: [0, null, 1],
        font: "inherit",
      }}>
      <Flex flexDirection={["column", null, "row"]} gap="xs">
        <LazyUserAvatar user={profile} />

        <Flex flexDirection="column" gap="sm">
          <Flex flexDirection="column" alignItems="flex-start">
            <Paragraph bold>
              {formatFullName(profile)}
              {profile.id === contextConsultantProfileId && ` (${t("JOB_REQUESTS.APPLY.WIZARD.YOU")})`}
            </Paragraph>
            <DottedList responsive>
              {profile.position?.name && (
                <DottedListItem sx={{ maxWidth: "100%" }}>
                  <Paragraph color="n700" ellipsis>
                    {profile.position.name}
                  </Paragraph>
                </DottedListItem>
              )}
              <DottedListItem sx={{ maxWidth: "100%" }}>
                <Paragraph color="n700" ellipsis>
                  {profile.email}
                </Paragraph>
              </DottedListItem>
            </DottedList>
          </Flex>
        </Flex>
      </Flex>
    </ResponsiveCard>
  );
};
